import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "bg-light mb-2 mt-3 py-1 px-2 shadow-sm rounded" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "d-flex justify-content-center" }, [
    /*#__PURE__*/ _createElementVNode("h5", { class: "mt-n3 mb-1 text-dark" }, "Endereço")
], -1);
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-6" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, [
    /*#__PURE__*/ _createTextVNode("CEP "),
    /*#__PURE__*/ _createElementVNode("small", null, [
        /*#__PURE__*/ _createTextVNode("("),
        /*#__PURE__*/ _createElementVNode("a", {
            target: "_blank",
            href: "http://www.buscacep.correios.com.br/sistemas/buscacep/"
        }, "Não sei meu cep"),
        /*#__PURE__*/ _createTextVNode(")")
    ])
], -1);
const _hoisted_6 = { class: "col-6" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Estado", -1);
const _hoisted_8 = { class: "col-6" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Cidade", -1);
const _hoisted_10 = { class: "col-6" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Bairro", -1);
const _hoisted_12 = { class: "col-12" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Endereço", -1);
const _hoisted_14 = { class: "col-6" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Número", -1);
const _hoisted_16 = { class: "col-6" };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("label", null, "Complemento", -1);
const _hoisted_18 = { class: "row" };
const _hoisted_19 = { class: "col-12" };
const _hoisted_20 = { class: "form-check custom-control custom-checkbox" };
const _hoisted_21 = {
    class: "custom-control-label",
    for: "concordo_termos_uso"
};
const _hoisted_22 = ["href"];
const _hoisted_23 = { class: "col-12" };
const _hoisted_24 = { class: "form-check custom-control custom-checkbox" };
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("label", {
    class: "custom-control-label",
    for: "aceita_receber_emails_marketing"
}, "Aceito receber notícias, promoções e novidades da Campanha do Bem.", -1);
const _hoisted_26 = { class: "col-12 mb-3" };
const _hoisted_27 = { class: "form-check custom-control custom-checkbox" };
const _hoisted_28 = {
    class: "custom-control-label",
    for: "possui_conta_bancaria"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_InputMasked = _resolveComponent("InputMasked");
    const _component_SelectUf = _resolveComponent("SelectUf");
    const _component_AutocompleteGenerico = _resolveComponent("AutocompleteGenerico");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_InputMasked, {
                    mask: "#####-###",
                    modelValue: _ctx.participante.cep,
                    "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event) => ((_ctx.participante.cep) = $event)),
                        _cache[1] || (_cache[1] = ($event) => (_ctx.changeCep()))
                    ],
                    required: ""
                }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_SelectUf, {
                    modelValue: _ctx.participante.uf,
                    "onUpdate:modelValue": [
                        _cache[2] || (_cache[2] = ($event) => ((_ctx.participante.uf) = $event)),
                        _cache[3] || (_cache[3] = ($event) => (_ctx.onChangeUf()))
                    ],
                    placeholder: "Estado onde você mora",
                    required: "",
                    tipo: "somente-estado"
                }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_AutocompleteGenerico, {
                    modelValue: _ctx.participante.municipio_id,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.participante.municipio_id) = $event)),
                    url: "/municipios/autocomplete",
                    "text-alias": "municipio",
                    placeholder: "Cidade onde você mora",
                    required: "",
                    pesquisaAdicional: {
                        uf: _ctx.participante.uf,
                    }
                }, null, 8, ["modelValue", "pesquisaAdicional"])
            ]),
            _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.participante.bairro) = $event)),
                    placeholder: "Informe o bairro onde você mora",
                    required: ""
                }, null, 512), [
                    [_vModelText, _ctx.participante.bairro]
                ])
            ]),
            _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.participante.logradouro) = $event)),
                    required: "",
                    placeholder: "Informe a rua/avenida onde você mora"
                }, null, 512), [
                    [_vModelText, _ctx.participante.logradouro]
                ])
            ]),
            _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.participante.numero) = $event)),
                    required: ""
                }, null, 512), [
                    [_vModelText, _ctx.participante.numero]
                ])
            ]),
            _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.participante.complemento) = $event)),
                    placeholder: "Exemplo: Bloco 15, AP 203"
                }, null, 512), [
                    [_vModelText, _ctx.participante.complemento]
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                    _withDirectives(_createElementVNode("input", {
                        id: "concordo_termos_uso",
                        name: "concordo_termos_uso",
                        class: "custom-control-input",
                        type: "checkbox",
                        required: "",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.participante.concordo_termos_uso) = $event))
                    }, null, 512), [
                        [_vModelCheckbox, _ctx.participante.concordo_termos_uso]
                    ]),
                    _createElementVNode("label", _hoisted_21, [
                        _createTextVNode("Concordo com os "),
                        _createElementVNode("a", {
                            target: "_blank",
                            style: { "margin-left": "5px" },
                            href: _ctx.urlTermosUso
                        }, "termos de uso", 8, _hoisted_22),
                        _createTextVNode(".")
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                    _withDirectives(_createElementVNode("input", {
                        id: "aceita_receber_emails_marketing",
                        name: "aceita_receber_emails_marketing",
                        class: "custom-control-input",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.participante.aceita_receber_emails_marketing) = $event))
                    }, null, 512), [
                        [_vModelCheckbox, _ctx.participante.aceita_receber_emails_marketing]
                    ]),
                    _hoisted_25
                ])
            ]),
            _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                    _withDirectives(_createElementVNode("input", {
                        id: "possui_conta_bancaria",
                        name: "possui_conta_bancaria",
                        class: "custom-control-input",
                        type: "checkbox",
                        required: "",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.participante.possui_conta_bancaria) = $event))
                    }, null, 512), [
                        [_vModelCheckbox, _ctx.participante.possui_conta_bancaria]
                    ]),
                    _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.participante.tipo == "F"
                        ? "Estou ciente que para receber as doações terei de indicar uma conta bancária vinculada ao CPF cadastrado e que não é possível alterar este CPF no futuro."
                        : "Estou ciente que para receber as doações terei de indicar uma conta bancária vinculada ao CNPJ cadastrado e que não é possível alterar este CNPJ no futuro."), 1)
                ])
            ])
        ])
    ]));
}
